




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'default-layout',
})
export default class DefaultLayout extends Vue {
}
